import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  template: `<p class="help is-danger" [class.hide]="_hide">{{_text}}</p>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./control-error.component.css']
})
export class ControlErrorComponent implements OnInit {
  _hide = true;

  constructor(private cdr: ChangeDetectorRef) {
  }

  _text;

  @Input() set text(value) {
    if (value !== this._text) {
      this._text = value;
      this._hide = !value;
      this.cdr.detectChanges();
    }
  }

  ngOnInit() {
  }

}
